export default "<router-outlet>\r\n\r\n</router-outlet>\r\n"